import { AnchorLink } from "@hub/ui/anchor-link";
import React from "react";
import styles from "./tile.module.css";

export interface TileProps {
  title: string;
  subtitle: string;
  description?: string;
  tag?: string;
  features?: string[];
  icons?: {
    primary: string;
    secondary: string;
  };
  id: string;
  path: string;
  enableClick?: boolean;
  enabled?: boolean;
  link: {
    path: string;
    label: string;
  };
  selected?: boolean;
}

const Tile: React.FC<TileProps> = ({ title, link }) => {
  return (
    <div className={styles.tile}>
      <span className={styles.tile__title}>{title}</span>
      <div className={styles.tile__buttonContainer}>
        <AnchorLink to={link.path} className={styles.tile__button}>
          {link.label}
        </AnchorLink>
      </div>
    </div>
  );
};

export default Tile;
